export const applicationStatuses = Object.freeze({
  CONNECTION_SUCCESS: true,
  CONNECTION_FAILURE: false,
  APPLICATION_BLOCK: true,
  APPLICATION_UNBLOCK: false
})
